import { render, staticRenderFns } from "./SafetyZhuanyeDialog.vue?vue&type=template&id=6cb85756&scoped=true"
import script from "./SafetyZhuanyeDialog.vue?vue&type=script&lang=js"
export * from "./SafetyZhuanyeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb85756",
  null
  
)

export default component.exports